import { Component, OnInit, Inject, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { takeUntil, map, take } from 'rxjs/operators';
import { Subject } from 'rxjs';

import { ContentMapperService } from '@shared/services/content/content-mapper.service';
import { ContentService } from '@shared/services/content/content.service';
import { ContentTypesEnum } from '@enums/content-type.enum';
import { FooterContent } from '@shared/services/content/_interfaces_/content.interface';
import { FooterContentMapped } from '@shared/services/content/_interfaces_/content.mapped.interface';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent implements OnInit, OnDestroy {
  public content: FooterContentMapped;
  private unsubscribeAll$: Subject<void> = new Subject();

  constructor(
    @Inject(ChangeDetectorRef) private cd: ChangeDetectorRef,
    @Inject(ContentMapperService) private contentMapperService: ContentMapperService,
    @Inject(ContentService) private contentService: ContentService,
    @Inject(TranslateService) private translateService: TranslateService
  ) {}

  public ngOnInit(): void {
    this.getContent();
    this.translateService.onLangChange.pipe(takeUntil(this.unsubscribeAll$)).subscribe(() => {
      this.cd.reattach();
      this.getContent();
    });
  }

  public getContent(): void {
    this.contentService
      .getContent<FooterContent>(ContentTypesEnum.genericFooter)
      .pipe(
        take(1),
        takeUntil(this.unsubscribeAll$),
        map((content: FooterContent) => this.contentMapperService.mapFooterContent(content))
      )
      .subscribe((content: FooterContentMapped) => ((this.content = content), this.cd.detectChanges(), this.cd.detach()));
  }

  public ngOnDestroy(): void {
    this.unsubscribeAll$.next();
    this.unsubscribeAll$.complete();
  }
}
